import { ReportMapEntity } from './report-map-entity.service';
import { CameraService } from './camera.service';
import { CoreService } from './core.service';
import { WindowService } from './window.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataContextService } from './data-context.service';
import { TimelineService } from './timeline.service';

export class AlertPinMapEntity extends ReportMapEntity {
  object: any;

  constructor(
    latitude: number,
    longitude: number,
    object: any,
    cameraService: CameraService,
    coreService: CoreService,
    windowService: WindowService,
    dataContextService: DataContextService,
    modalService: NgbModal,
    timelineService: TimelineService,
  ) {
    super(
      'alert', // id
      'ArcAngel//AlertPins',
      'ArcAngel//AlertPins',
      'assets/img/social-media/birdtweet.png',
      latitude,
      longitude,
      0, // altitude
      new Date(), // timestamp
      '', // source
      cameraService,
      coreService,
      windowService,
      dataContextService,
      modalService,timelineService
    );
    this.object = object;
    this.setTimestamp(new Date());
    this.setShowInLayersUI(false);
  }
}